/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Services_TitleInputs */

const en_landing_services_title = /** @type {(inputs: Landing_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ways to train.`)
};

const pl_landing_services_title = /** @type {(inputs: Landing_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak można trenować.`)
};

/**
* | output |
* | --- |
* | "Ways to train." |
*
* @param {Landing_Services_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_services_title = /** @type {((inputs?: Landing_Services_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Services_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_services_title(inputs)
	return en_landing_services_title(inputs)
});